export default __webpack_public_path__ + "static/media/hero-4.8e429074.svg";